var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2092",
    d: "M21.1858 18.6165C23.4422 18.6303 25.7041 18.5805 27.9633 18.5943C29.1957 18.6018 30.4441 18.4823 31.6697 18.4898",
    stroke: "#33333A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2093",
    d: "M21.1637 22.2413C24.4617 22.2614 27.7413 22.2179 31.0458 22.2381",
    stroke: "#33333A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2094",
    d: "M21.0718 26.3711L29.4179 26.422",
    stroke: "#33333A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2095",
    d: "M17.0407 24.0164C17.0452 23.2796 16.8775 22.5273 16.8819 21.8014C16.8975 19.2569 15.3038 12.895 18.6202 12.9153C19.6824 12.9218 20.7662 12.7644 21.817 12.7708L31.3373 12.8289L33.7294 12.8435C34.5207 12.8484 35.4811 12.702 36.2454 12.9227C36.4773 12.9896 37.1509 12.8145 37.1719 13.1925C37.1892 13.5038 37.3407 13.7624 37.3386 14.0955C37.3349 14.7133 37.5029 15.4027 37.4988 16.0644C37.4942 16.8206 37.5454 17.5391 37.5713 18.297C37.6858 21.6368 37.5304 25.0046 37.5099 28.3642C37.5076 28.7364 37.5531 29.1385 37.436 29.4935C37.3523 29.7472 37.455 30.3649 37.3051 30.5587C37.2085 30.6835 37.0716 31.2361 37.0608 31.3954C37.0356 31.7661 36.9042 32.1004 36.8821 32.4602C36.8371 33.1923 36.1821 33.6773 35.8186 34.2577C35.4918 34.7795 34.663 35.2421 34.0701 35.3996C33.7723 35.4786 33.5265 35.7285 33.2018 35.7951C32.8259 35.8723 32.3743 35.9586 31.9951 35.9563L27.8665 35.9311C25.219 35.915 22.5544 35.9807 19.9196 35.9646C18.4439 35.9556 16.9231 36.0283 15.4221 36.0192C12.0339 35.0354 15.682 33.7865 16.516 32.3769C16.8232 31.8577 16.997 31.1691 17.0006 30.5759L17.0266 26.3122L17.0407 24.0164Z",
    stroke: "#33333A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipt);
export default __webpack_public_path__ + "static/media/recipt.fd1fbd54067267444825a1be4c02526d.svg";
export { ForwardRef as ReactComponent };